import React from 'react'
import ReactDOM from 'react-dom/client'

export function validateEmail(email) {
  const re = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/g
  return re.test(email)
}

export function truncateText(value, maxLength = 20) {
  if (!value || value.length <= maxLength) {
    return value
  }

  return value.slice(0, maxLength)
}
